export default {
    state: {
        selectedDay: new Date(),
    },
    mutations: {
        setSelectedDay(state, v) {
            state.selectedDay = v;
        },
    },
    actions: {
        loadMonthPlans(store, {params}) {
            return this.dispatch('sendRequest', {path: '/diary/month-plan', params});
        },
        createMonthPlan(store, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/diary/month-plan', method: 'post', data, formErrors});
        },
        updateMonthPlan(store, {data, formErrors, id}) {
            return this.dispatch('sendRequest', {path: '/diary/month-plan/'+id, method: 'post', data, formErrors});
        },
        deleteMonthPlan(store, {id}) {
            return this.dispatch('sendRequest', {path: '/diary/month-plan/'+id, method: 'delete'});
        },
        changeMonthPlanDone(store, {id, data}) {
            return this.dispatch('sendRequest', {path: '/diary/month-plan/'+id+'/done', method: 'post', data});
        },

        loadWeekPlans(store, {params}) {
            return this.dispatch('sendRequest', {path: '/diary/week-plan', params});
        },
        createWeekPlan(store, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/diary/week-plan', method: 'post', data, formErrors});
        },
        updateWeekPlan(store, {data, formErrors, id}) {
            return this.dispatch('sendRequest', {path: '/diary/week-plan/'+id, method: 'post', data, formErrors});
        },
        deleteWeekPlan(store, {id}) {
            return this.dispatch('sendRequest', {path: '/diary/week-plan/'+id, method: 'delete'});
        },
        changeWeekPlanDone(store, {id, data}) {
            return this.dispatch('sendRequest', {path: '/diary/week-plan/'+id+'/done', method: 'post', data});
        },

        loadDayPlans(store, {params}) {
            return this.dispatch('sendRequest', {path: '/diary/day-plan', params});
        },
        createDayPlan(store, {data, formErrors}) {
            return this.dispatch('sendRequest', {path: '/diary/day-plan', method: 'post', data, formErrors});
        },
        updateDayPlan(store, {data, formErrors, id}) {
            return this.dispatch('sendRequest', {path: '/diary/day-plan/'+id, method: 'post', data, formErrors});
        },
        deleteDayPlan(store, {id}) {
            return this.dispatch('sendRequest', {path: '/diary/day-plan/'+id, method: 'delete'});
        },
        changeDayPlanDone(store, {id, data}) {
            return this.dispatch('sendRequest', {path: '/diary/day-plan/'+id+'/done', method: 'post', data});
        },
    }
}